import {
  TRewardPoints,
  TRewardPointsUpdateData,
  TUidCodeData,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const rewardPointsService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['list'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRetailerPoints: builder.query<
        { data: TRewardPoints[]; totalCount: number },
        string
      >({
        query: (params) => ({
          url: 'retailers/search',
          method: 'GET',
          params: {
            mobile: params,
          },
        }),
        transformResponse: (data: TRewardPoints) => ({
          data: [data],
          totalCount: 1,
        }),
        providesTags: ['list'],
      }),
      addRewardPoints: builder.mutation<
        void,
        {
          retailerId: number;
          data: TRewardPointsUpdateData;
        }
      >({
        query: ({ retailerId, data }) => {
          return {
            url: `retailers/${retailerId}/reward-points`,
            method: 'POST',
            data,
          };
        },
      }),
      removeRewardPoints: builder.mutation<
        void,
        {
          retailerId: number;
          data: TRewardPointsUpdateData;
        }
      >({
        query: ({ retailerId, data }) => {
          return {
            url: `retailers/${retailerId}/deduct-points`,
            method: 'POST',
            data,
          };
        },
      }),
      verifyUidCode: builder.query<TUidCodeData, string>({
        query: (uidCode) => ({
          method: 'GET',
          url: `product/scan/reward-points/${uidCode}`,
        }),
      }),
    }),
  });

export const {
  useGetRetailerPointsQuery,
  useAddRewardPointsMutation,
  useRemoveRewardPointsMutation,
  useLazyVerifyUidCodeQuery,
} = rewardPointsService;
